export default function postStudyComment(user, data) {
    let token = localStorage.getItem("token");
    let url = `/wp-json/achim/v1/study/comment/user/${user}`;

    let formData = new FormData();
    for (const name in data) {
        formData.append(name, data[name]);
    }

    let headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.set('Authorization', 'Bearer ' + token);

    let options = {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers,
        body: formData
    };
    return fetch(url, options)
        .then((response) => {
            return response.json();
        })
        .then((jsonObject) => {
            return jsonObject;
        });
}